import React from "react";
import { NavLink, useRouteMatch } from "react-router-dom";
import ReactTooltip from "react-tooltip";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import classnames from "classnames";
import "./NavDropdownMenu.scss";

const NavDropdownMenu = ({ menuLink, className, id }) => {
  let match = useRouteMatch({
    path: `/${menuLink.slug}`,
    exact: false,
  });

  return (
    <li
      id={id + "__dropdown-menu-item__container"}
      className={classnames("dropdown-menu-item__container", className, match ? "active" : "")}
    >
      <span className="main-nav-links__dropdown-item" data-for={id} data-tip>
        <span aria-label={menuLink.name} id={`${menuLink.slug}-nav-item`}>
          {menuLink.name}
          <ExpandMoreIcon className="arrow-icon" role="presentation" />
        </span>
      </span>
      <ReactTooltip
        id={id}
        className="dropdown-menu__tooltip"
        effect="solid"
        delayHide={200}
        delayUpdate={500}
        place={"bottom"}
        clickable={true}
        arrowColor="transparent"
        backgroundColor="#121e59"
      >
        <div className="dropdown-menu">
          <ul>
            {menuLink.links.map((x) => {
              return (
                <li key={x.name} className="dropdown-menu__links">
                  <NavLink to={`/${x.path}`} exact={x.exact} aria-label={`visit ${x.name} page`}>
                    {x.name}
                  </NavLink>
                </li>
              );
            })}
          </ul>
        </div>
      </ReactTooltip>
    </li>
  );
};

export default NavDropdownMenu;
